export default __webpack_public_path__ + "static/media/E17C5D70-FE9E-4CBB-9604-D8E9BEDF9F58_1_105_c.248f289a.jpeg";